<div class="unavailable-slot-dialog d-flex flex-wrap justify-content-center align-items-center hide theme-interface"
    #unavailableSlotDialog>
    <div class="selection-container p-4 position-absolute">
        <div class="header-container d-flex flex-wrap">
            <div class="w-100">
                <div
                    class="text-center justify-content-center font-size-header py-4 font-weight-bold theme-color-header">
                    {{ (suggestedSlot && suggestedSlot.startTime ? 'public.checkout.errors.slotUnavailable' :
                    'public.checkout.errors.orderSubmissionFailed') | translate}}
                    <span
                        class="float-right position-absolute closebutton text-decoration-underline font-weight-bold theme-color-header"
                        (click)="dismissUnavailableSlotDialog()">{{'public.global.close'
                        | translate}}<i class="fas fa-times pl-2 theme-color-header"></i></span>
                </div>
                <div class="font-size-primary">
                    {{(suggestedSlot && suggestedSlot.startTime ?
                    'public.checkout.errors.slotUnavailableExplanationWithSuggestion' :
                    'public.checkout.errors.slotUnavailableExplanation') | translate}}
                </div>
                <ng-container *ngIf="suggestedSlot && suggestedSlot.startTime">
                    <div class="text-center my-2">
                        {{formattedSuggestedTime()}}
                    </div>
                    <div class="text-center">
                        {{formattedSuggestedDate()}}
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="body-container py-2">
            <div class="font-size-primary text-center text-unselectable">
                <a href="#" class="btn theme-dark btn-dark px-5 py-1" (throttledClick)="updateOrder($event)"
                    appPreventDoubleClick [throttleTime]="5000">
                    {{ (suggestedSlot && suggestedSlot.startTime ? 'public.checkout.updateOrder' : 'public.dialog.ok') |
                    translate}}
                </a>
            </div>
        </div>
    </div>
</div>